import TimelineRow from "./TimelineRow";

// Las entradas del timeline en fila, sin agruparlas. Es lo que se muestra
// cuando agrupar por turnos mentiría: en una ejecución anterior al registro
// por corrida, cada paso lleva las marcas de tiempo de su última pasada, así
// que el orden entre pasos y esperas no se sostiene.
//
// Usa la misma fila que la pestaña de timeline para que una entrada se lea
// igual en los dos lados.

export default function EntryList({ entries, onSelectEntry }) {
  if (!entries?.length) {
    return (
      <div className="flex h-32 items-center justify-center text-xs text-gray-500">
        Nothing was recorded for this execution.
      </div>
    );
  }

  return (
    <div className="divide-y divide-white/5 overflow-hidden rounded-xl border border-white/10 bg-zinc-900/40">
      {entries.map((entry) => (
        <TimelineRow key={entry.seq} entry={entry} onSelect={onSelectEntry} />
      ))}
    </div>
  );
}
